import MuiInputAdornment from '@material-ui/core/InputAdornment';

export default MuiInputAdornment;
